let data: any = {
  "ACC_API_URL": "_ACC_API_URL",
  "ACC_CLIENT_ID": "_ACC_CLIENT_ID",
  "ACC_CLIENT_SECRET": "_ACC_CLIENT_SECRET",
  "ACC_LOGIN_PATH": "_ACC_LOGIN_PATH",
  "ACC_WEBSITE_NAME": "_ACC_WEBSITE_NAME",
}

export default data